<script module lang="ts">
	export interface BaseHeadingProps {
		token: Tokens.Heading;
		options: MarkdownOptions | undefined;
		renderers: Renderers | undefined;
		class?: string;
	}
</script>

<script lang="ts">
	import type { MarkdownOptions, Renderers } from '@magidoc/plugin-svelte-marked';

	import classNames from 'classnames';
	import type { Tokens } from 'marked';
	import { Txt, type TxtVariant } from '../../../../Txt';
	import { MarkdownInlineTokens } from '../../MarkdownInlineTokens';

	let { ...props }: BaseHeadingProps = $props();
	export const options: MarkdownOptions | undefined = undefined;
	export const renderers: Renderers | undefined = undefined;

	const MarkdownHeadingVariantMap: Record<number, TxtVariant> = {
		1: 'h1',
		2: 'h2',
		3: 'h3',
		4: 'h4',
		5: 'h5',
		6: 'h6'
	} as const;

	let variant = $derived(MarkdownHeadingVariantMap[props.token.depth]);
</script>

<Txt {variant} class={classNames('mb-6', props.class)}>
	<MarkdownInlineTokens
		{variant}
		class={props.class}
		tokens={props.token.tokens}
		{options}
		{renderers}
	/>
</Txt>
